<template>
    <v-container
        class="pa-12 fill-height align-start"
        fluid
    >
        <template v-if="loading">
            <v-overlay :value="loading">
                <v-progress-circular
                    :size="100"
                    color="white"
                    indeterminate
                ></v-progress-circular>
            </v-overlay>
        </template>
        <template v-else>
            <v-row>
                <v-col>
                    <div class="headline">Education levels</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6" class="d-flex align-center py-4">
                    <v-card width="660" flat color="grey lighten-4">
                        <v-row align="center" class="px-6">
                            <v-col class="px-0">
                                <v-text-field
                                    v-model="newLevelName"
                                    outlined
                                    dense
                                    hide-details
                                    label="New education level"
                                    color="primary"
                                    type="text"
                                    class="mr-3"
                                ></v-text-field>
                            </v-col>
                            <v-col class="px-0 flex-shrink-0 flex-grow-0">
                                <v-btn 
                                    small 
                                    depressed
                                    color="primary"
                                    height="40px" 
                                    :disabled="!newLevelName"
                                    @click="createLevel"
                                >Save</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>                    
                </v-col>
            </v-row>
            <v-card
                outlined
                width="660"
            >
                <template v-if="levels.length > 0">
                    <template v-for="(level, index) in levels">   
                        <v-list-item
                            :key="index"
                            class="pa-0"
                        >
                            <v-row justify="space-between" align="center" class="px-4 py-0">
                                <v-col>
                                    <span 
                                        class="subtitle-1"
                                        v-text="level.name"
                                    ></span>
                                </v-col>
                                <v-col class="text-right">
                                    <v-btn
                                        icon
                                        color="primary"
                                        class="mr-1"
                                        @click="updateLevelEventHandler(level, index)"
                                    ><v-icon>mdi-pencil</v-icon></v-btn>
                                    <v-btn
                                        icon
                                        color="secondary"
                                        @click="deleteLevelEventHandler(level, index)"
                                    ><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider
                            v-if="index + 1 < levels.length"
                            :key="'a'+index"
                        ></v-divider>
                    </template>
                </template>
                <template v-else>
                    <div class="subtitle-1 pa-4">No records</div>
                </template>                
            </v-card>
        </template>
        <!-- Update level bottom sheet -->
        <v-bottom-sheet v-model="updateLevelSheet">
            <v-sheet class="text-center">                
                <v-row no-gutters justify="center" class="py-6">
                    <v-col cols="12" md="8" lg="4">
                        <v-text-field
                            v-model="selectedLevelObject.name"
                            label="Level name"
                            dense
                            outlined
                        ></v-text-field>
                        <div class="d-flex">
                            <v-btn 
                                depressed 
                                small 
                                color="primary"
                                class="mx-auto"
                                @click="updateLevel"
                            >Update</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                small
                                color="secondary"
                                @click="updateLevelSheet = false"
                            >close</v-btn>
                        </div>
                    </v-col>                                           
                </v-row>              
            </v-sheet>
        </v-bottom-sheet>
        <!-- Delete level bottom sheet -->
        <v-bottom-sheet v-model="deleteLevelSheet">
            <v-sheet class="text-center py-4">
                <div class="py-3">Are you sure you want to delete this eduaction level?</div>
                <v-btn
                    text
                    color="secondary"
                    @click="deleteLevel"
                >Yes</v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="deleteLevelSheet = false"
                >No</v-btn>
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'educationLevels',
        data: () => ({
            levels: [],
            newLevelName: '',
            newLevelLangaudeId: 0,
            selectedLevelObject: {
                index: 0,
                id: 0,
                name: '',
                label: '',
                description: '',
                languageId: 0
            },
            deleteLevelSheet: false,
            updateLevelSheet: false,
            loading: true
        }),
        computed: {
            ...mapGetters(['languages', 'defaultLanguage'])
        },
        mounted() {
            this.fetchLevels()
        },
        methods: {
            async fetchLevels() {
                await this.axios.get('/EducationLevel/GetAll', {
                    params: {
                        languageId: this.defaultLanguage.id
                    }
                })
                .then(reseponse => {
                    this.levels = reseponse.data.list
                    this.loading = false
                })
                .catch(error => { console.log(error) })
            },
            createLevel() {
                const data = {
                    name: this.newLevelName,
                    label: this.newLevelName,
                    description: this.newLevelName,
                    languageId: this.defaultLanguage.id
                }
                this.axios.post('/EducationLevel/CreateEducationLevel', data)
                .then(reseponse => {
                    this.levels.push(reseponse.data)
                    const snackbar = {
                        show: true,
                        message: 'Education level created successfully'
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
                .catch(error => { console.log(error) })
            },
            updateLevelEventHandler(level, index) {
                this.updateLevelSheet = true
                this.selectedLevelObject.index = index
                this.selectedLevelObject.id = level.id
                this.selectedLevelObject.name = level.name
                this.selectedLevelObject.label = level.label
                this.selectedLevelObject.description = level.description
                this.selectedLevelObject.languageId = level.languageId
            },
            updateLevel() {
                const data = {
                    id: this.selectedLevelObject.id,
                    name: this.selectedLevelObject.name,
                    label: this.selectedLevelObject.name,
                    description: this.selectedLevelObject.name,
                    languageId: this.selectedLevelObject.languageId
                }
                this.axios.post('/EducationLevel/UpdateEducationLevel', data)
                .then(response => {
                    this.updateLevelSheet = false
                    this.levels[this.selectedLevelObject.index] = response.data
                    const snackbar = {
                        show: true,
                        message: 'Education level updated successfully'
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
                .catch(error => { console.log(error) })
            },
            deleteLevelEventHandler(level, index) {
                this.deleteLevelSheet = true
                this.selectedLevelObject.index = index
                this.selectedLevelObject.id = level.id
                this.selectedLevelObject.name = level.name
                this.selectedLevelObject.label = level.label
                this.selectedLevelObject.description = level.description
                this.selectedLevelObject.languageId = level.languageId
            },            
            deleteLevel() {
                const data = {
                    id: this.selectedLevelObject.id,
                    languageId: this.selectedLevelObject.languageId
                }
                this.axios.delete('/EducationLevel/DeleteEducationLevel', {
                    params: data
                })
                .then(reseponse => {
                    this.levels.splice(this.selectedLevelObject.index, 1)

                    this.deleteLevelSheet = false

                    const snackbar = {
                        show: true,
                        message: 'Education level created successfully'
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
                .catch(error => { console.log(error) })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>